// TODO: expand to take in more types than just string[] and return appropriately guarded type
export const convertToInt = (array: string[]): number[] =>
  array.map((id) => parseInt(id, 10))
